import { Directive, Input, Output, inject } from "@angular/core";

// eslint-disable-next-line no-restricted-imports
import { InViewportDirective as InViewportBaseDirective, InViewportOptions } from "ng-in-viewport";

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: "[inViewport]",
    standalone: true,
    hostDirectives: [InViewportBaseDirective],
})
export class InViewportDirective {
    private readonly inViewportBaseDirective = inject(InViewportBaseDirective);

    @Input({
        alias: "inViewportOptions",
    })
    public set options(value: InViewportOptions) {
        this.inViewportBaseDirective.options = value;
    }
    @Output() public inViewportChanged = this.inViewportBaseDirective.inViewportAction;
    @Output() public inViewportCustomCheck = this.inViewportBaseDirective.inViewportCustomCheck;
}
